import { atom } from "jotai";
import { atomWithReset } from "jotai/utils";

import { BACKGROUND_TYPE, type BackgroundType } from "@design-lab/shared/constants";

export type ViewSnapshot = {
  zoom: number;
  pan: { x: number; y: number };
  backgroundType: BackgroundType;
};

// Controls visibility of the Refine Artwork overlay
export const refineArtworkOpenAtom = atom(false);

// Stores the view snapshot taken when Refine Artwork is opened
export const refineViewSnapshotAtom = atom<ViewSnapshot | null>(null);

export const artboardBackgroundAtom = atom<BackgroundType>(BACKGROUND_TYPE.SHIRT);

// Brush size for erase tool (in pixels)
export const eraseBrushSizeAtom = atomWithReset<number>(1);

export const mobileSizePlacementOpenAtom = atom(false);

// Brush type for erase tool
export type BrushType = "quick-selection" | "manual";
export const brushTypeAtom = atomWithReset<BrushType>("quick-selection");

// Tracks when user is interacting with the brush size slider
export const brushSizeSliderActiveAtom = atom<boolean>(false);

// Tracks when AI image refinement is generating
export const aiRefineGeneratingAtom = atom<boolean>(false);

// Interaction mode for refine artwork
export type InteractionMode = "cursor" | "pan" | "crop";
export const interactionModeAtom = atomWithReset<InteractionMode>("cursor");
